import { t } from "../../validation/validator";

export const UpdatePinRequestSchema = t.type({
  pin: t.number,
});

export const UpdatePinResponseSchema = t.type({
  status: t.string,
});

export type UpdatePinResponse = t.TypeOf<typeof UpdatePinResponseSchema>;

export const AuthApis = {
  Auth: {
    UpdatePin: {
      Name: "auth-updatePin",
      Request: UpdatePinRequestSchema,
      Response: UpdatePinResponseSchema,
    },
  },
};
